import axios from 'axios'
import {SlidersQueryResponse} from '../../modules/apps/slider/sliders-list/core/_models'
import {EmployeesQueryResponse} from '../../modules/apps/employee/employees-list/core/_models'
import {About} from '../../modules/apps/about/abouts-list/core/_models'
import {News, NewsQueryResponse} from '../../modules/apps/news/news-list/core/_models'
import {Admission} from '../../modules/apps/admission/admissions-list/core/_models'
import {ID} from '../../../_metronic/helpers'
import {GallerysQueryResponse} from '../../modules/apps/gallery/gallerys-list/core/_models'
const API_URL = process.env.REACT_APP_API_URL + '/frontend'

export const getSliders = (query: string): Promise<SlidersQueryResponse> =>
  axios.get(`${API_URL}/slider?${query}`)

export const getEmployees = (query: string): Promise<EmployeesQueryResponse> =>
  axios.get(`${API_URL}/employee?${query}`)

export const getGallerys = (query: string): Promise<GallerysQueryResponse> =>
  axios.get(`${API_URL}/gallery?${query}`)

export const getAbouts = (query?: string): Promise<About> => axios.get(`${API_URL}/about?${query}`)
export const getNews = (query?: string): Promise<NewsQueryResponse> =>
  axios.get(`${API_URL}/news?${query}`)

export const getNewsById = (id: ID): Promise<News | undefined> => axios.get(`${API_URL}/news/${id}`)
export const createAdmission = (admission: Admission): Promise<Admission | undefined> =>
  axios.post(API_URL + '/admission', admission)
